/**
 * The `Home` function renders the main home page of the Linnae application.
 * It displays different content based on the user's authentication status.
 * 
 * - If the user is authenticated, it shows the `MainStepper` function inside a container.
 * - If the user is unauthenticated, it shows the `Aside` function and a centered logo with the application name.
 * 
 * The function also fetches and sets the user's profile data from Microsoft Graph API if the user is authenticated.
 * 
 * @returns {JSX.Element} The rendered home page function.
 */

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import logolinnae from "../../assets/images/linnae-logo.png";
import Aside from "@front-ends/common/src/components/app/AsideLogin";
import MainStepper from "./MainStepper";
import { InteractionStatus } from "@azure/msal-browser";
import { callMsGraphMe } from "@front-ends/common/src/utils/MsGraphApiCall";
import { useState, useEffect } from "react";
import { GraphData } from "@front-ends/common/src/components/ui/ProfileData";
import { profileRequest as loginRequestLinnae} from "../../authConfigLinnae";
import { useTranslation } from "react-i18next";

export function Home() {

  const { t } = useTranslation();
  
  const { instance, inProgress ,accounts} = useMsal();
  const [graphData, setGraphData] = useState<null|GraphData>(null);

  const account = instance.getActiveAccount() ;
    useEffect(() => {
      if (!graphData && inProgress === InteractionStatus.None && account) {
          instance
          .acquireTokenSilent({
              ...loginRequestLinnae,
              account: accounts[0],
          })
          .then((response) => {
              callMsGraphMe(response.accessToken)
              .then(data => {
                  setGraphData(data);
              });
          });
      }
  }, [inProgress, graphData, instance]);

  return (
    <>
      <AuthenticatedTemplate>
        <Container maxWidth="lg">
          <MainStepper />
        </Container>
      </AuthenticatedTemplate>
      
      <UnauthenticatedTemplate>
        <Aside connexionLabel={t("connect-button")} />
        <Box
          sx = {{
            textAlign: "center",
            position: "fixed",
            top: "30%",
            left: "55%",
            zIndex: 5,
          }}
        >
        <Box
          component="img"
          sx={{
            width: "375px",
            height: "300px",
          }}
          src={logolinnae}
        />
          <Typography
            color="inherit"
            variant="h5"
            fontWeight={600}
          >
            Linnae
          </Typography>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
}

